import './Loader.scss';

import logo from './Logo_skinny.png'

const Loader = () => {
  return(
    <div className='loader'>
      <img src={logo} alt='logo' className='loader_logo'/>
      <p className='loader_txt'>Loading...</p>
    </div>
  )
}

export default Loader;